import { differenceBy } from 'lodash'
import moment from 'moment'
export const calculateAbsentPercentage = slots => {
  const slotsToCalculate = slots.filter(i => i.category !== 'last')
  if (!slotsToCalculate.length) {
    return 0
  }
  const absentSlots = slotsToCalculate.reduce(
    (acc, s) =>
      (acc +=
        s.status === 'absent'
          ? 1
          : s.status === 'approved-absent'
          ? 0.5
          : s.status === 'late'
          ? 0.33
          : 0),
    0
  )
  return Math.round((absentSlots * 1000) / slotsToCalculate.length) / 10
}

export const isNullOrUndefined = value => value === null || value === undefined

export const renderSlotCategory = i =>
  i === 'last'
    ? 'Buổi cuối'
    : i === 'first'
    ? 'Buổi đầu'
    : i === 'middle_exam'
    ? 'Buổi chấm giữa môn'
    : 'Buổi thường'

export const upsertMany = (array, $newValues, by = i => i.id, replace = false) => {
  const newValues = Array.isArray($newValues) ? $newValues : [$newValues]

  const toPush = differenceBy(newValues, array, i => i.id)
  const output = array.map(i => {
    const newValueThatMatch = newValues.find(j => j.id === i.id)
    if (newValueThatMatch) {
      if (replace) {
        return newValueThatMatch
      } else {
        return { ...i, ...newValueThatMatch }
      }
    }
    return i
  })

  return [...output, ...toPush]
}

export const getRankFromOverallScore = overallAvg => {
  if (!overallAvg && overallAvg !== 0) {
    return null
  }
  if (overallAvg >= 9) {
    return 'excellent'
  }
  if (overallAvg >= 8) {
    return 'very_good'
  }
  if (overallAvg >= 6.45) {
    return 'good'
  }
  // if (overallAvg >= 6) {
  //   return 'above_average'
  // }
  if (overallAvg >= 5) {
    return 'average'
  }
  return 'bad'
}

export const getRankLabel = v => {
  if (v === 'excellent') return 'Xuất sắc'
  if (v === 'very_good') return 'Giỏi'
  if (v === 'good') return 'Khá'
  //if (v === 'above_average') return 'Trung bình khá'
  if (v === 'average') return 'Trung bình'
  if (v === 'bad') return 'Yếu'
  return ''
}

export function getStudentStatusLabel(status) {
  if (status === 'reserved') return 'Bảo Lưu'
  if (status === 'active') return 'Hoạt Động'
  if (status === 'deactive') return 'Thôi học'
  if (status === 'aborted') return 'Thôi học'
  if (status === 'graduated') return 'Đã kết thúc CT'
  return status
}

export const getStudentStatusList = () => {
  return [
    { label: 'Hoạt Động', value: 'active' },
    { label: 'Thôi học', value: 'deactive' },
    { label: 'Bảo Lưu', value: 'reserved' }
  ]
}
export const getStudentRankList = () => {
  return ['excellent', 'very_good', 'good', 'above_average', 'average', 'bad'].map(i => ({
    value: i,
    label: getRankLabel(i)
  }))
}

export function getStudentStatusColor(status) {
  if (status === 'active') return 'green'
  if (status === 'reserved') return 'orange'
  else return 'gray'
}

export const sortListByName = inputList => {
  return [...inputList].sort((a, b) => {
    const aname = a.name.trim().toLowerCase().split(/\s+/)
    const bname = b.name.trim().toLowerCase().split(/\s+/)
    let compareIndex = 0
    let res
    while (!res && compareIndex < Math.min(aname.length, bname.length)) {
      res = aname[aname.length - 1 - compareIndex].localeCompare(
        bname[bname.length - 1 - compareIndex],
        'vi'
      )
      compareIndex++
    }
    if (!res) {
      return Math.sign(aname.length - bname.length)
    }
    return res
  })
}

export function formatDate(v) {
  return moment(v).format('DD/MM/YYYY')
}
export function formatDateTime(v) {
  return moment(v).format('DD/MM/YYYY [lúc] HH:mm')
}

export const formatStartDateForAccountSheet = v => moment(v).add(1, 'second').format('DD/MM/YYYY')

export const transformDateForDatePicker = v => {
  if (!v) {
    return v
  }
  const output = moment(v).format('YYYY-MM-DD')
  return output
}

export function getDayLabel(date) {
  const dateMoment = moment(date)
  const day = dateMoment.get('day')
  const label = day === 0 ? 'CN' : 'Thứ ' + (day + 1)
  return label
}
export const formatCurrency = (i, keepUnit = false) => {
  if (!i) {
    return i
  }
  const currency = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND'
  })
  if (!keepUnit) {
    return currency.format(i).slice(0, -1).replace(/\./g, ',')
  }
  return currency.format(i).replace(/\./g, ',')
}

export const getImgUrl = v => {
  if (!v) {
    return ''
  }
  return new URL(v, process.env.VUE_APP_API_ENDPOINT).toString()
}
export const getAuthFromStorage = () => {
  const data = localStorage.getItem('lms')
  try {
    const jsonData = JSON.parse(data)
    return jsonData.auth
  } catch (error) {
    console.error(error)
    return null
  }
}

export function getStatusColor(status) {
  if (status === 'active') return 'green'
  else return 'red'
}

export const getManagerTypeLabel = i => {
  switch (i) {
    case 'accountant':
      return 'Kế toán'

    case 'education_manager':
      return 'Quản lý đào tạo'

    case 'manager':
      return 'Nhân viên'
    case 'super_admin':
      return 'Quản lý cao cấp'

    default:
      return i
  }
}

export function genderOptions() {
  return [
    { text: 'Nam', value: 'male' },
    { text: 'Nữ', value: 'female' },
    { text: 'Khác', value: 'others' }
  ]
}
export function studentTypeOptions() {
  return [
    { text: 'HV Ngắn hạn', value: 'short_term' },
    { text: 'HV Dài hạn', value: 'long_term' }
  ]
}
export function reasonTypeOptions() {
  return [
    { value: 'time', text: 'Thời gian' },
    { value: 'health', text: 'Sức khỏe' },
    { value: 'finance', text: 'Tài chính' },
    { value: 'not_suitable_major', text: 'Ngành học không phù hợp' },
    { value: 'course_quality', text: 'Chất lượng khóa học' },
    { value: 'family', text: 'Gia đình' },
    { value: 'others', text: 'Lý do khác' }
  ]
}

export const getReasonTypeLabel = key => {
  const match = reasonTypeOptions().find(i => i.value === key) || {}
  return match.text || key
}

export function tuitionStatusOptions() {
  return Array(6)
    .fill(0)
    .map((_, i) => ({
      value: i,
      text: `Học kỳ ${i + 1}`
    }))
}

export function getTuitionStatusLabel(key) {
  if (key === undefined || key === null) {
    return ''
  }
  if (key > 5) {
    return ''
  }
  return 'Học kỳ ' + (key + 1)
}

export const getGenderLabel = i => {
  switch (i) {
    case 'male':
      return 'Nam'
    case 'female':
      return 'Nữ'
    case 'others':
      return 'Khác'
    default:
      return i
  }
}
export const getPaymentMethodLabel = i => {
  switch (i) {
    case 'cash':
      return 'Tiền mặt'
    case 'bank_transfer':
      return 'Chuyển khoản'
    default:
      return i
  }
}

export const getMonths = () =>
  Array(12)
    .fill(0)
    .map((_, index) => ({ value: index + 1, text: `Tháng ${index + 1}` }))

export const getTeacherStatus = (includeAll = false) => [
  ...(includeAll
    ? [
        {
          value: 'all',
          text: 'Tất cả'
        }
      ]
    : []),
  {
    value: 'active',
    text: 'Đang dạy'
  },
  {
    value: 'blocked',
    text: 'Đã dừng'
  }
]

export function getStatusLabel(status) {
  if (status === 'active') return 'Hoạt động'
  if (status === 'blocked') return 'Đã khóa'
  return ''
}

// export const getReservationStatusLabel = item => {
//   if (!item) {
//     return ''
//   }
//   if (!item.end_date) {
//     return 'Hoạt động'
//   }

//   switch (item.status) {
//     case 'active':
//       if (!item.end_date) return 'Hoạt động'
//       const stillRemain = moment().isBefore(item.end_date)
//       if (stillRemain) {
//         return 'Hoạt động'
//       }
//       return 'Kết thúc'

//     default:
//       return 'Đã hủy'
//   }
// }

export const getPaymentMethodOptions = () => [
  { value: 'cash', text: 'Tiền mặt' },
  { value: 'bank_transfer', text: 'Chuyển khoản' }
]

export const getReservationStatus = item => {
  if (item.actual_return_date && moment().isSameOrAfter(item.actual_return_date)) {
    return 'returned'
  }
  if (item.end_date && moment().isAfter(item.end_date)) {
    return 'expired'
  }
  if (moment().isBefore(item.start_date)) {
    return 'waiting'
  }
  return 'active'
}

export const getReservationStatusLabel = status => {
  switch (status) {
    case 'returned':
      return 'Đã quay lại học'
    case 'expired':
      return 'Hết thời hạn bảo lưu'
    case 'waiting':
      return 'Chưa tới ngày bảo lưu'

    default:
      return 'Đang trong thời gian bảo lưu'
  }
}

export const getReservationStatusOptions = () => [
  { value: 'active', text: 'Đang trong thời gian bảo lưu' },
  { value: 'expired', text: 'Hết thời hạn bảo lưu' },
  { value: 'waiting', text: 'Chưa tới ngày bảo lưu' },
  { value: 'returned', text: 'Đã quay lại học' }
]
